import React, { Component } from 'react';
import { Link } from "react-router-dom";
import _ from "lodash";
import HsForm from 'react-hubspot-form'
import Header from "./Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MetaTags from 'react-meta-tags';

class HubspotForm extends Component {


  render() {

    return (
      <div className="contact">
        <MetaTags>
          <title>Contact Us, Euro Film Launches</title>
          <meta name="description" content="Contact Gruvi, the digital agency that built & manages Euro Film Launches." />
          <meta property="og:title" content="Contact Us, Euro Film Launches" />
        </MetaTags>
        <div className="contact-form">
          <Link className="header__back" to="/">
            <FontAwesomeIcon icon="chevron-left" />
            <div>Back</div>
          </Link>
          <div className="contact-form__title"><FontAwesomeIcon icon="exclamation-triangle" /><h3>Contact Us</h3></div>
          <HsForm
            portalId='3477242'
            formId="eb237377-2710-48fa-85f6-b6ca003737c7"
            onSubmit={() => console.log('Submit!')}
            onReady={(form) => console.log('Form ready!')}
            loading={<div>Loading...</div>}
          />
        </div>
      </div>
    );
  }

}

export default HubspotForm;



// WEBPACK FOOTER //
// ./src/components/ContactPage.js